// extracted by mini-css-extract-plugin
export default {"bounce":"r_cf","loading":"r_cg","logo-mark-bounce-right":"r_ch","logo-mark-bounce-left":"r_cj"};